module.exports = __webpack_public_path__ + "img/_8.f35572cf.png";